// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"GroupUserAttributeList_tableHeader_26k_k","capitalize":"GroupUserAttributeList_capitalize_1G5Ig"};